import ActivityTimeline from './activity_timeline';
import AddDocumentModal from './modal/add_document';
import AddNoteModal from './modal/notes/add_note';
import AddReminderModal from './modal/reminder/add_reminder';
import { brand } from '../../theme/themePrimitives';
import CardWrapper from '../wrapper/card';
import ContactsComponent from './contact';
import DealInfoComponent from './deal_info';
import { fetchDealDetailThunk } from '../../redux/thunks/deal';
import { settingSelectedNote } from '../../redux/slices/note';
import StartACallModal from './modal/start_a_call';
import { styled } from '@mui/system';
import { AddIcCallOutlined, AddOutlined, CalendarMonthOutlined, ChatBubbleOutlineOutlined, EditOutlined, FileOpenOutlined, KeyboardArrowLeft, MailOutlined } from '@mui/icons-material';
import { AppDispatch, RootState } from '../../redux/store';
import { Box, Button, Menu, MenuItem, Typography } from '@mui/material';
import { settingComposingFlagEmail, settingSelectedEmail } from '../../redux/slices/email';
import { settingSelectedEmailAndSMSTab, settingViewDetail } from '../../redux/slices/deal';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect, useState } from 'react';

// Styled Components
const Container = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    padding: '20px'
});

const LeftColumn = styled(Box)({
    flex: 1,
    marginRight: '20px',
    maxWidth: '400px'
});

const RightColumn = styled(Box)({
    flex: 2
});

// Component
const DealDetails = () => {
    const dispatch = useDispatch<AppDispatch>();
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
    const [addNote, setAddNote] = useState<boolean>(false);
    const [addReminder, setAddReminder] = useState<boolean>(false);
    const [startACall, setStartACall] = useState<boolean>(false);
    const [addDocument, setAddDocument] = useState<boolean>(false);
    const { selectedDealDetail, selectedDeal, loaders } = useSelector((state: RootState) => state.deal);

    useEffect(() => {
        const fetchDealDetail = async () => {
            try {
                await dispatch(fetchDealDetailThunk(selectedDeal?.id || 0)).unwrap();
            } catch (e) {
                // Catch errors
            }
        };
        fetchDealDetail();
    }, []);

    const goBackHandler = () => {
        dispatch(settingViewDetail(false));
    };

    const handleAnchorElement = (e: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(e.currentTarget);
    };
    return (
        <Container minHeight="80vh" overflow="auto">
            {/* Header */}
            <CardWrapper display="flex" alignItems="center" justifyContent="space-between">
                <Button variant="text" color="secondary" onClick={goBackHandler}><KeyboardArrowLeft /> Back to pipeline</Button>
                <Typography variant="h5" color={brand[300]} maxWidth="700px" overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">{selectedDealDetail?.title}</Typography>
                <Button variant="contained" color="primary" endIcon={<AddOutlined />} onClick={handleAnchorElement} disabled={loaders.isLoading}>
                    Quick Actions
                </Button>
                <Menu
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={() => setAnchorEl(null)}
                    MenuListProps={{
                        'aria-labelledby': 'add-pipeline-button'
                    }}
                >
                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        setStartACall(true);
                    }}>
                        <Box display="flex" gap={2} alignItems="center">
                            <AddIcCallOutlined />
                            <Typography variant="body1">Start a Call</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        setAddDocument(true);
                    }}>
                        <Box display="flex" gap={2} alignItems="center">
                            <FileOpenOutlined />
                            <Typography variant="body1">Add a Document</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        dispatch(settingSelectedEmail(null));
                        dispatch(settingComposingFlagEmail(false));
                        dispatch(settingSelectedEmailAndSMSTab(true));
                    }}>
                        <Box display="flex" gap={2} alignItems="center">
                            <MailOutlined />
                            <Typography variant="body1">Send Mail</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        setAddNote(true);
                        dispatch(settingSelectedNote(null));
                    }}>
                        <Box display="flex" gap={2} alignItems="center">
                            <EditOutlined />
                            <Typography variant="body1">Add a Note</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        setAddReminder(true);
                    }}>
                        <Box display="flex" gap={2} alignItems="center">
                            <CalendarMonthOutlined />
                            <Typography variant="body1">Set a Reminder</Typography>
                        </Box>
                    </MenuItem>
                    <MenuItem onClick={() => {
                        setAnchorEl(null);
                        dispatch(settingSelectedEmailAndSMSTab(false));
                    }}>
                        <Box display="flex" gap={2} alignItems="center">
                            <ChatBubbleOutlineOutlined />
                            <Typography variant="body1">Send SMS</Typography>
                        </Box>
                    </MenuItem>
                </Menu>
            </CardWrapper>

            {/* Main Content */}
            <Box display="flex" mt={2}>
                {/* Left Column */}
                <LeftColumn>
                    <DealInfoComponent />
                    <Box pt={2}>
                        <ContactsComponent />
                    </Box>
                </LeftColumn>

                {/* Right Column */}
                <RightColumn>
                    <ActivityTimeline />
                </RightColumn>
            </Box>
            {addNote && <AddNoteModal open={addNote} onClose={() => setAddNote(false)} />}
            {addReminder && <AddReminderModal open={addReminder} onClose={() => setAddReminder(false)} />}
            {startACall && <StartACallModal open={startACall} onClose={() => setStartACall(false)} />}
            {addDocument && <AddDocumentModal open={addDocument} onClose={() => setAddDocument(false)} />}
        </Container>
    );
};

export default DealDetails;
